/* src/app/request-details/request-details.component.css */
.round-button {
  border-radius: 1.5em;
}
/*# sourceMappingURL=request-details.component.css.map */
